import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=475e06f2"
import script from "./Accordion.vue?vue&type=script&lang=js"
export * from "./Accordion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Button: require('/srv/app/components/button/Button.vue').default,Markdown: require('/srv/app/components/markdown/Markdown.vue').default,Icon: require('/srv/app/components/icon/Icon.vue').default})
